import Swal from "sweetalert2";
import { useHistory } from "react-router-dom";
import { Field, Form } from 'react-final-form';
import React, { useState, useEffect } from 'react';
import { Button } from '@/shared/components/Button';
import AdminInterface from '@/utils/AdminInterface';
import withReactContent from "sweetalert2-react-content";
import { MissionProviderRoleEnum } from '../../../../../Enums';
import renderSelectField from '@/shared/components/form/Select';
import { Card, CardBody, CardTitleWrap, CardTitle } from '@/shared/components/Card';
import { FormButtonToolbar, FormContainer, FormGroup, FormGroupField, FormGroupLabel } from '@/shared/components/form/FormElements';

const required = value => (value ? undefined : 'Required')

const NewMissionProvider = (props) => {
    const history = useHistory();
    const [licenses, setLicenses] = useState();
    const [providers, setProviders] = useState();
    const [licensorIsSelected, setLicensorIsSelected] = useState(false);
    
    const getProviders = () => {
        AdminInterface.instance.getProviders().then((response) => {
            setProviders(response.data)
        }).catch(() => {
            withReactContent(Swal).fire({
                icon: 'error',
                title: 'Error',
                html: 'Error in getting providers.',
            });
        });
    }

    const getLicenses = () => {
        AdminInterface.instance.getLicenses().then((response) => {
            setLicenses(response.data)
        }).catch(() => {
            withReactContent(Swal).fire({
                icon: 'error',
                title: 'Error',
                html: 'Error in getting licenses.',
            });
        });
    }

    useEffect(() => {
        if (licenses === undefined) return;
        getProviders();
    }, [licenses]);

    useEffect(() => {
        if (props.location.state === undefined) return;
        getLicenses();
    }, [props.location.state]);

    const submitNewMissionProvider = (missionProvider) => {
        let data = {}
        data.providerId = missionProvider.providerId?.value;
        data.role = missionProvider.role?.value;
        data.licenseId = missionProvider.licenseId?.value;
        data.missionId = missionProvider.missionId;
        AdminInterface.instance.createMissionProvider(data).then(() => {
            withReactContent(Swal).fire({
                icon: 'success',
                title: 'Success',
                html: 'New mission provider is created!',
            });
        }).catch(() => {
            withReactContent(Swal).fire({
                icon: 'error',
                title: 'Error',
                html: 'Error happend in assigning provider to the mission.',
            });
        });
    }

    const handleRoleChange = (form, value) => {
        if (value.value === 1) {
            setLicensorIsSelected(true);
        } else {
            form.change('licenseId', { value: undefined, label: undefined });
            setLicensorIsSelected(false);
        }
        return value;
    }

    return (
        <Card>
            <CardBody>
                <CardTitleWrap>
                    <CardTitle>New Mission Provider</CardTitle>
                </CardTitleWrap>
                {providers && <Form onSubmit={submitNewMissionProvider}>
                    {({ handleSubmit, form }) => (
                        <FormContainer horizontal onSubmit={handleSubmit}>
                            <FormGroup>
                                <FormGroupLabel>Mission Id</FormGroupLabel>
                                <FormGroupField>
                                    <Field name="missionId" component="input" type="text" placeholder="Mission Id" initialValue={props.location.state} disabled={true} />
                                </FormGroupField>
                            </FormGroup>
                            <FormGroup>
                                <FormGroupLabel>Provider</FormGroupLabel>
                                <FormGroupField>
                                    <Field name="providerId" component={renderSelectField} validate={required}
                                        options={providers.map(function (provider) {
                                            return { value: provider.id, label: provider.name }
                                        })}
                                    />
                                </FormGroupField>
                            </FormGroup>
                            <FormGroup>
                                <FormGroupLabel>Role</FormGroupLabel>
                                <FormGroupField>
                                    <Field name="role" component={renderSelectField} validate={required} parse={(value) => handleRoleChange(form, value)}
                                        options={Object.keys(MissionProviderRoleEnum).map(function (key) {
                                            return { value: MissionProviderRoleEnum[key], label: key }
                                        })}
                                    />
                                </FormGroupField>
                            </FormGroup>
                            <FormGroup>
                                <FormGroupLabel>License</FormGroupLabel>
                                <FormGroupField>
                                    <Field name="licenseId" component={renderSelectField} isDisabled={!licensorIsSelected} validate={required}
                                        options={licenses.map(function (license) {
                                            return { value: license.id, label: license.name }
                                        })}
                                    />
                                </FormGroupField>
                            </FormGroup>
                            <FormButtonToolbar>
                                <Button variant="primary" type="submit">Submit</Button>
                                <Button variant="secondary" type="button" onClick={() => history.goBack()}>
                                    Back
                                </Button>
                            </FormButtonToolbar>
                        </FormContainer>
                    )}
                </Form>}
            </CardBody>
        </Card>
    );
};

export default NewMissionProvider;